require('./brokerWarrantsAdvancedBuyStep2.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const classNames = require('classnames');

// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @constants
const {
    FIRST_STEP,
    SECOND_STEP,
    BROKER_CONDITION_OVER_WARRANT_PRICE,
    BROKER_STOCKS_ADVANCED_BUY_FIELDS_MAXLENGHT_LIMIT,
    BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_MODIFIER,
    BROKER_BUY_FOR_AMOUNT_OF_TITLES,
    BROKER_BUY_FOR_APPROX_IMPORT,
    BROKER_STOCKS_ADVANCED_BUY_FIELDS_AMOUNT_MAXLENGHT_LIMIT
} = require('constants/index');
const nonNumericRegex = /[^\d]/g;
const language = getLanguage();

// @ commons
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const { InputSafe } = require('commonsComponents/inputSafe');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKMessage } = require('commonsComponents/OKMessage');
const { AmountInput } = require('commonsComponents/amountInput');

// @ actions
const BrokerWarrantsAdvancedBuyActions = require('actions/brokerWarrantsAdvancedBuy');

class BrokerWarrantsAdvancedBuyStep2 extends React.Component {

    constructor(props) {
        super(props);
        this.handleTitleQuantityChanged = this.handleTitleQuantityChanged.bind(this);
        this.onApproxImportChanged = this.onApproxImportChanged.bind(this);
        this.onLimitedValueChanged = this.onLimitedValueChanged.bind(this);
    }

    onApproxImportChanged(value) {
        this.props.approxImportChanged(value);
    }

    onLimitedValueChanged(value) {
        this.props.limitedValueChanged(value);
    }

    buildBuyForInput(buyFor, buyForTitleQuantity, buyForApproxImport) {
        const { immBrokerWarrantsAdvancedBuy } = this.props;
        const invalidBuyFor = immBrokerWarrantsAdvancedBuy.getIn(['steps', SECOND_STEP, 'invalidBuyFor']);
        const buyForTitles = buyFor === BROKER_BUY_FOR_AMOUNT_OF_TITLES;
        const className = classNames('warrants-advanced-buy-step2__text-input-wrapper', {
            'warrants-advanced-buy-step2__text-input-wrapper--left': buyForTitles
        });

        let input;

        if (buyForTitles) {
            input = (
                <InputSafe
                    type="text"
                    autoComplete="off"
                    value={buyForTitleQuantity}
                    onChange={this.handleTitleQuantityChanged}
                    maxLength={BROKER_STOCKS_ADVANCED_BUY_FIELDS_MAXLENGHT_LIMIT}
                    errorState={invalidBuyFor}
                    errorMessage={formatText('broker-warrantsAdvancedBuyBuyForTitlesErrorMessage')}
                />
            );
        } else {
            input = (
                <AmountInput
                    amount={buyForApproxImport}
                    callback={this.onApproxImportChanged}
                    max={BROKER_STOCKS_ADVANCED_BUY_FIELDS_AMOUNT_MAXLENGHT_LIMIT}
                    error={invalidBuyFor}
                    errorMsg={formatText('broker-warrantsAdvancedBuyBuyForAproxAmountErrorMessage')}
                    language={language}
                    hideFocusZero
                />
            );
        }

        return (
            <div className={className}>
                {input}
            </div>
        );
    }

    buildStocksContractDropdownOptions() {
        const { immStocksContract, immBrokerWallets } = this.props;
        const immContractValues = immBrokerWallets.get('contractsValues');
        const immWalletList = immBrokerWallets.get('walletList');

        const processedStocksContract = immStocksContract.map((entry, index) => {
            const walletNumber = entry.get('walletNumber');
            const immContract = immContractValues.find(
                contract => contract.getIn(['contrato', 'numerodecontrato']) === walletNumber
            );

            let walletBalance = {};

            if (immContract) {
                const associatedAccount = immWalletList.getIn(
                    [immContract.get('contractNumberShort'), 'associatedAccount']
                );

                if (associatedAccount && associatedAccount.balance) {
                    walletBalance = {
                        amount: associatedAccount.balance.balance,
                        currency: associatedAccount.balance.currency
                    };
                }
            }

            return entry.merge({ value: index, walletBalance });
        });

        return processedStocksContract.toJS();
    }

    buildStocksContractDropdownPlaceholder() {
        return (
            <div>
                <FormattedText value="broker-stocksContractDropdownPlaceholder" />
            </div>
        );
    }

    conditionOverUnderlying(buyForTitleQuantity) {
        return (
            <div className="warrants-advanced-buy-step2__text-input-wrapper warrants-advanced-buy-step2__text-input-wrapper--no-left warrants-advanced-buy-step2__group-div ">
                <InputSafe
                    label={formatText('broker-warrantsAdvancedBuyAmountOfTitlesLabel')}
                    type="text"
                    value={buyForTitleQuantity}
                    autoComplete="off"
                    onChange={this.handleTitleQuantityChanged}
                    maxLength={BROKER_STOCKS_ADVANCED_BUY_FIELDS_MAXLENGHT_LIMIT}
                />
            </div>
        );
    }

    conditionOverWarrant(buyFor, buyForTitleQuantity, buyForApproxImport, onBuyForChanged) {

        const buyForConditionalInput = this.buildBuyForInput(buyFor, buyForTitleQuantity, buyForApproxImport);

        return (
            <div className="warrants-advanced-buy-step2__group-div">

                <h2 className="warrants-advanced-buy-step2__subtitle">
                    <FormattedText value="broker-warrantsAdvancedBuyBuyFor" /> <OKTooltip content="tooltip-text" offset={[0, -10]} />
                </h2>
                <RadioButtonGroup
                    selectedValue={buyFor}
                    onChange={onBuyForChanged}
                    name="warrantsAdvancedBuyFor"
                    idPrefix="warrantsAdvancedBuyFor"
                >
                    <RadioButton
                        label={formatText('broker-warrantsAdvancedBuyAmountOfTitlesLabel')}
                        value={BROKER_BUY_FOR_AMOUNT_OF_TITLES}
                        className="warrants-advanced-buy-step2__radio-button"
                    />

                    <RadioButton
                        label={formatText('broker-warrantsAdvancedBuyApproxImportLabel')}
                        value={BROKER_BUY_FOR_APPROX_IMPORT}
                        className="warrants-advanced-buy-step2__radio-button"
                    />
                </RadioButtonGroup>

                {buyForConditionalInput}

            </div>
        );
    }

    handleTitleQuantityChanged(event) {
        this.props.titleQuantityChanged(event.target.value.replace(nonNumericRegex, "").trim());
    }

    render() {
        const { immBrokerWarrantsAdvancedBuy, stockContractChanged, onBuyForChanged, immAccounts, immStocksContract } = this.props;
        const steps = immBrokerWarrantsAdvancedBuy.get('steps');
        const step1 = steps.get(FIRST_STEP);
        const step2 = steps.get(SECOND_STEP);
        const stocksContractDropdownOptions = this.buildStocksContractDropdownOptions();
        const stocksContractPlaceholder = formatText('broker-stocksContractDropdownPlaceholder');
        const stocksContractSelectedValue = step2.get('selectedOptionValue');
        const orderType = step1.get('orderType');
        const buyFor = step2.get('buyFor');
        const titleQuantity = step2.get('titleQuantity');
        const buyForApproxImport = step2.get('buyForApproxImport');
        const limitPrice = step2.get('limitPrice');
        const invalidSelectedOption = step2.get('invalidSelectedOption');
        const invalidLimitPrice = step2.get('invalidLimitPrice');
        const conditionOverWarrant = this.conditionOverWarrant(buyFor, titleQuantity, buyForApproxImport, onBuyForChanged);
        const conditionOverUnderlying = this.conditionOverUnderlying(titleQuantity);

        const typeSpecificInputs =
            orderType === BROKER_CONDITION_OVER_WARRANT_PRICE ?
                conditionOverWarrant :
                conditionOverUnderlying;

        const selectedOptionErrorMessage = formatText('broker-warrantsAdvancedBuySelectedOptionErrorMessage');
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');

        return (
            <div className="warrants-advanced-buy-step2">
                <header className="warrants-advanced-buy-step2__header">
                    <h2 className="warrants-advanced-buy-step2__header-title">
                        <FormattedText value="broker-stocksAdvancedBuyStep2HeaderTitle" />
                    </h2>
                </header>
                <FormattedText value="broker-stocksAdvancedBuyStep2InstructionsText" className="warrants-advanced-buy-step2__info-text" />

                <div className="warrants-advanced-buy-step2__dropdown">
                    <StocksContractDropdown
                        immAccounts={immAccounts}
                        immBrokerStocksContract={immStocksContract}
                        label="broker-warrantsAdvancedBuyDropdownTitle"
                        onStockContractChange={stockContractChanged}
                        options={stocksContractDropdownOptions}
                        selectedValue={stocksContractSelectedValue}
                        placeholder={stocksContractPlaceholder}
                        modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_MODIFIER}
                        errorState={invalidSelectedOption}
                        errorMessage={selectedOptionErrorMessage}
                        loading={isBlockedAccountsLoading}
                    />
                </div>

                {typeSpecificInputs}

                <div className="warrants-advanced-buy-step2__group-div">
                    <h2 className="warrants-advanced-buy-step2__subtitle">
                        <FormattedText value="broker-warrantsAdvancedBuyLimitPriceLabel" />
                    </h2>
                    <div className="warrants-advanced-buy-step2__text-input-wrapper warrants-advanced-buy-step2__text-input-wrapper--no-left">
                        <AmountInput
                            amount={limitPrice}
                            callback={this.onLimitedValueChanged}
                            max={BROKER_STOCKS_ADVANCED_BUY_FIELDS_AMOUNT_MAXLENGHT_LIMIT}
                            error={invalidLimitPrice}
                            errorMsg={formatText('broker-warrantsAdvancedBuyLimitPriceErrorMessage')}
                            language={language}
                            hideFocusZero
                        />
                    </div>
                </div>

                <div className="warrants-advanced-buy-step2__group-div">
                    <OKMessage
                        id="warrants-advanced-buy-step2-disclaimer"
                        type="informative"
                        visible={true}
                        extraClass="warrants-advanced-buy-step2__disclaimer"
                    >
                        <FormattedText value="broker-warrantsAdvancedBuyStep2Disclaimer" />
                    </OKMessage>
                </div>
            </div>
        );
    }
}

BrokerWarrantsAdvancedBuyStep2.propTypes = {
    immBrokerWallets: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerWarrantsAdvancedBuy: PropTypes.object.isRequired,
    immStocksContract: PropTypes.object.isRequired,
    stockContractChanged: PropTypes.func.isRequired,
    titleQuantityChanged: PropTypes.func.isRequired,
    onBuyForChanged: PropTypes.func.isRequired,
    limitedValueChanged: PropTypes.func.isRequired,
    approxImportChanged: PropTypes.func.isRequired
};

module.exports.constructor = BrokerWarrantsAdvancedBuyStep2;

module.exports.BrokerWarrantsAdvancedBuyStep2 = connect((state) => ({
    immBrokerWallets: state.brokerWallets,
    immAccounts: state.accounts,
    immStocksContract: state.brokerStocksContract
}), {
        stockContractChanged: BrokerWarrantsAdvancedBuyActions.stockContractChanged,
        titleQuantityChanged: BrokerWarrantsAdvancedBuyActions.titleQuantityChanged,
        onBuyForChanged: BrokerWarrantsAdvancedBuyActions.buyForChanged,
        limitedValueChanged: BrokerWarrantsAdvancedBuyActions.limitedValueChanged,
        approxImportChanged: BrokerWarrantsAdvancedBuyActions.approxImportChanged
    })(BrokerWarrantsAdvancedBuyStep2);
